import { useTranslation } from 'react-i18next';
import {
    AlertDialog,
    AlertDialogAction,
    AlertDialogCancel,
    AlertDialogContent,
    AlertDialogDescription,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogTitle,
} from '../../ui/alert-dialog';

interface RemoveEquipmentDialogProps {
    itemName: string | null;
    onConfirm: () => void;
    onClose: () => void;
}

export default function RemoveEquipmentDialog({
    itemName,
    onConfirm,
    onClose,
}: RemoveEquipmentDialogProps) {
    const { t } = useTranslation();

    return (
        <AlertDialog
            open={itemName !== null}
            onOpenChange={(open) => !open && onClose()}
        >
            <AlertDialogContent>
                <AlertDialogHeader>
                    <AlertDialogTitle>
                        {t('roomOverview.equipment.removeTitle')}
                    </AlertDialogTitle>
                    <AlertDialogDescription>
                        {t('roomOverview.equipment.removeDescription', {
                            name: itemName,
                        })}
                    </AlertDialogDescription>
                </AlertDialogHeader>
                <AlertDialogFooter>
                    <AlertDialogCancel>
                        {t('roomOverview.equipment.form.cancel')}
                    </AlertDialogCancel>
                    <AlertDialogAction onClick={onConfirm}>
                        {t('roomOverview.equipment.remove')}
                    </AlertDialogAction>
                </AlertDialogFooter>
            </AlertDialogContent>
        </AlertDialog>
    );
}
